export const ENV_PROFILE = process.env.VUE_APP_ENV_PROFILE;
export const SERVER_API_URL = process.env.VUE_APP_ROOT_API;
export const ANGULAR_WEB_URL = process.env.VUE_APP_ANGULAR_WEB_URL;
export const SOCKET_URL = `${process.env.VUE_APP_SOCKET_URL}`;
export const AWS_ASSETS_URL = ENV_PROFILE === 'production' ? 'https://asset.legacyfuneral.com.br/' : 'https://assets-legacy.hml.ucsbr.com.br/';
export const CLOUDINARY_URL = 'https://res.cloudinary.com/legacyapp/image/upload/';
export const phoneMask = ['(##) ####-####', '(##) #####-####'];
export const cpfCnpjMask = ['###.###.###-##', '##.###.###/####-##'];
export const cpfMask = '###.###.###-##';
export const rgMask = 'SS-##.###.###';
export const GOOGLE_RECAPTCHA_KEY_ID = `${process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY_ID}`
export const PAGARME_PUBLIC_KEY = `${process.env.VUE_APP_PAGARME_PUBLIC_KEY}`

